import { cn } from "@/lib/utils";
import { Squircle } from "@/components/ui/squircle";

interface IProps {
  image: string;
  heading: string;
  category?: string;
  onClick: (id: number) => void;
  id: number;
  connected?: boolean;
  focused?: boolean;
}

export const CardWithImageAndHeading = ({
  image,
  heading,
  category,
  onClick,
  id,
  connected,
  focused,
}: IProps) => {
  return (
    <div
      className={cn(
        "cursor-pointer flex flex-col justify-center items-center px-2 py-1.5 rounded-[14px] relative",
        "transition-colors duration-100 ease-out",
        "border border-transparent",
        "hover:bg-card-hover hover:border-border",
        focused && "bg-card-hover",
        "group"
      )}
      onClick={() => onClick(id)}
    >
      {connected && (
        <div
          className="absolute top-1.5 right-1.5 w-[6px] h-[6px] rounded-full bg-emerald-400"
          style={{ boxShadow: '0 0 6px rgba(52, 211, 153, 0.5)' }}
        />
      )}
      <Squircle
        size="sm"
        className="w-10 h-10 flex items-center justify-center overflow-hidden"
      >
        <img
          src={image}
          alt={heading}
          className="w-10 h-10 object-contain"
        />
      </Squircle>
      <span className="font-normal text-[11px] text-center mt-1 text-muted-foreground group-hover:text-foreground transition-colors duration-150 leading-tight line-clamp-1">
        {heading}
      </span>
      {category && (
        <span className="font-light text-[10px] text-center text-muted-foreground leading-tight line-clamp-1">
          {category}
        </span>
      )}
    </div>
  );
};
